export default {"src":"/_next/static/media/azure-sql-database.1371a218.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};